module.exports = __webpack_public_path__ + "img/tear_cover_flat_adhesive_box2.ac336292.png";